import { BaseController } from "./BaseController";
import { PaymentRepository } from "../repository/PaymentRepository";

/**
 * 사용자 관련 비즈니스 로직을 처리하는 Controller 클래스입니다.
 */
export class PaymentController extends BaseController {
  static instance = null;

  /**
   * PaymentController의 인스턴스를 반환합니다.
   * @returns {PaymentController} PaymentController 인스턴스
   */
  static getInstance() {
    if (!PaymentController.instance) {
      PaymentController.instance = new PaymentController();
    }
    return PaymentController.instance;
  }

  /**
   * TierController 생성자
   */
  constructor() {
    super(new PaymentRepository());
  }

  /**
   * Stripe 주문 정보를 생성합니다.
   * @returns {Promise<object>} Stripe 주문 위젯 URI
   */
  async create(address, tierId, metadata) {
    try {
      if (!address) {
        throw new Error("지갑 주소가 필요합니다.");
      }

      if (!tierId) {
        throw new Error("티어 정보가 필요합니다.");
      }

      if (!metadata || !metadata.image_id) {
        throw new Error("메타데이터 정보가 필요합니다.");
      }

      return await this.repository.create(address, tierId, metadata.image_id);
    } catch (error) {
      console.error("Error in payment.create:", error);
      throw error;
    }
  }
}
